export default "__VITE_ASSET__4fb1cf7d__"